export const settings = {
  // baseUrl: "http://tfs-dgk:8784",
  // baseUrl: "https://localhost:44369",
  // baseUrl: "https://uhs.unionhealthsolutions.com/MaxChats",
  // baseUrl: "http://tfs-server:8073",
  // baseUrl: "http://localhost:5179",
  baseUrl: "https://communication.mremind.com/MaxChatsAPI",

  chatuser: {
    login: "/api/User/Login",
    sendOtp: "/api/User/SendOTP?email=[email]",
    verifyOTP: "/api/User/VerifyOTP?email=[email]&otp=[otp]",
    resetPassword: "/api/User/ResetPassword?email=[email]&password=[password]",
    refreshToken:
      "/api/User/RefreshAccessToken?refreshAccessToken=[refreshAccessToken]",
    addUser: "/api/User/AddUser",
    addUserContacts: "/api/User/AddUserContacts",
    updateUser: "/api/User/UpdateUser",
    updateUserContact: "/api/User/UpdateUserContact",
    getUsers:
      "/api/User/GetUsers?page=[page]&pageSize=[pageSize]&username=[username]&depId=[depId]&status=[status]",
    getUserById: "/api/User/GetUserById?UserId=[UserId]",
    getUsersCSV:
      "/api/User/GetUsersCSV?page=[page]&pageSize=[pageSize]&username=[username]&depId=[depId]&status=[status]",
    ExportUserContactsToExcel:
      "/api/User/GetUserContactsBase64?UserId=[UserId]",
    getUsersList: "/api/User/GetUsersList",
    getUserContactsById: "/api/User/GetUserContacts?UserId=[UserId]",
    getRolesList: "/api/User/GetRolesList",
    getDesignationListById:
      "/api/User/GetDesignationList?DepertmentId=[DepertmentId]",
    getDepertmentList: "/api/User/GetDepertmentList",
    getUserContactStatusLists:
      "/api/User/GetUserContactStatusLists?userId=$[userId]",
    addUserContacts: "/api/User/AddUserContacts?newexternal=$[newexternal]",
    addCallRecords: "/api/Call/AddCallRecords",
    getUserContactsByParams:
      "/api/User/GetUserContacts?UserId=[UserId]&Rows=[Rows]&PageNumber=[PageNumber]&isFav=[isFav]&isExternal=[IsExternal]&UserName=[UserName]",
    getAutoForward: "/api/Chat/GetAutoForwarning?isExternal=[isExternal]",
    updateAutoForwardTeam: "/api/Chat/UpdateAutoForwardTeam",
  },

  rccall: {
    oauthLogin: "/api/RCCall/oauth/login?AccessToken=[AccessToken]",
    me: "/api/RCCall/me?AccessToken=[AccessToken]",
    sipInfo: "/api/RCCall/sip-info?appUserId=[appUserId]",
    allocateExtension: "/api/RCCall/allocate-extension?appUserId=[appUserId]",
    releaseExtension: "/api/RCCall/release-extension?appUserId=[appUserId]",
    extensionHeartbeat: "/api/RCCall/extension-heartbeat?appUserId=[appUserId]",
    callStatus: "/api/RCCall/call-status?toNumber=[toNumber]&appUserId=[appUserId]",
    incomingCaller: "/api/RCCall/incoming-caller",
    startRecording:
      "/api/RCCall/start-recording?appUserId=[appUserId]&telephonySessionId=[telephonySessionId]&partyId=[partyId]",
    stopRecording:
      "/api/RCCall/stop-recording?appUserId=[appUserId]&telephonySessionId=[telephonySessionId]&partyId=[partyId]&recordingId=[recordingId]",
    recordingContent: "/api/RCCall/recording-content?recordingId=[recordingId]",
    sessionRecording:
      "/api/RCCall/session-recording?telephonySessionId=[telephonySessionId]",
    recordingsList: "/api/RCCall/recordings?perPage=[perPage]",
  },

  chats: {
    getUserChats:
      "/api/Chat/GetUserChats?userId=$[userId]&isFav=$[isFav]&ishide=$[ishide]&IsExternal=$[isExternal]&Autoforward=$[Autoforward]",
    getExternalChats: "/api/Call/SendSms?tempID=$[tempID]",
    getSearchUserChats:
      "/api/Chat/GetUserChats?userId=$[userId]&isFav=$[isFav]&IsAdmin=$[IsAdmin]",
    getSearchUserContacts:
      "/api/User/GetUserContacts?userId=$[userId]&IsAdmin=$[IsAdmin]",
    addChat: "/api/Chat/AddChat",
    updateChat: "/api/Chat/UpdateChat",
    updateNameChat: "/api/Chat/UpdateChat?DeleteName=$[DeleteName]",
    updateFavChat: "/api/Chat/UpdateFavChat",
    removeChatParticipant: "/api/Chat/RemoveChatParticipant",
    addChatParticipant: "/api/Chat/AddChatParticipant",
    getChatMessages:
      "/api/Chat/GetChatMessages?userId=$[userId]&chatId=$[chatId]&isAdmin=$[isAdmin]&page=$[page]&pageSize=$[pagesize]",
    getChatMessagesUser:
      "/api/Chat/GetChatMessages?userId=$[userId]&chatId=$[chatId]",
    getUserContacts: "/api/User/GetUserContacts?userId=$[userId]",
    getSearchUserContacts:
      "/api/User/GetUserContacts?userId=$[userId]&IsAdmin=$[IsAdmin]&Rows=$[Rows]&PageNumber=$[PageNumber]",
    addChatMessage: "/api/Chat/AddChatMessage",
    GetChatAttachments: "/api/Chat/GetChatAttachments?ChatId=$[ChatId]",
    GetChatParticipants:
      "/api/Chat/GetChatParticipants?ChatId=$[ChatId]&UserId=$[UserId]",
    getCallHistory:
      "/api/Call/GetRecentCalls?clientIdentifier=$[clientIdentifier]&conference=$[conference]",
    getCallRecordings:
      "/api/Call/get-recording?AutoRecording=$[autoRecording]&sid=$[sid]",
    getMissedCallCount: "/api/Call/GetMissedCallRecords?UserId=$[userId]",
    addAutoForwarning: "/api/Chat/AddAutoForwarning?newteam=$[newteam]",
    addExternalChat:
      "/api/Chat/AddExternalChat?ExternalPersonContactNo=$[ExternalPersonContactNo]",
  },
  emails: {
    getEmailsList:
      "/api/Email/GetEmailsList?UserId=$[UserId]&PageNumber=$[PageNumber]&Rows=$[Rows]&Text=$[Text]&Date=$[Date]&HasAttachment=$[HasAttachment]",
    getEmailsListSent:
      "/api/Email/GetEmailsList?UserId=$[UserId]&PageNumber=$[PageNumber]&Rows=$[Rows]&IsSent=$[IsSent]&Text=$[Text]&Date=$[Date]&HasAttachment=$[HasAttachment]",
    getEmailsListDraft:
      "/api/Email/GetEmailsList?UserId=$[UserId]&PageNumber=$[PageNumber]&Rows=$[Rows]&IsDraft=$[IsDraft]&Text=$[Text]",
    getEmailsListFav:
      "/api/Email/GetEmailsList?UserId=$[UserId]&PageNumber=$[PageNumber]&Rows=$[Rows]&IsFav=$[IsFav]&Text=$[Text]&Date=$[Date]&HasAttachment=$[HasAttachment]",
    getEmailsListTrash:
      "/api/Email/GetEmailsList?UserId=$[UserId]&PageNumber=$[PageNumber]&Rows=$[Rows]&IsTrash=$[IsTrash]&Text=$[Text]",
    getIndividualFoldersEmailsList:
      "/api/Email/GetEmailsList?UserId=$[UserId]&PageNumber=$[PageNumber]&Rows=$[Rows]&FolderId=$[FolderId]&Text=$[Text]&Date=$[Date]&HasAttachment=$[HasAttachment]",
    getEmailDetail: "/api/Email/GetEmailDetail?EmailId=$[EmailId]",
    sendEmail: "/api/Email/SendEmail",
    updateEmail: "/api/Email/UpdateEmail",
    getUserFolders: "/api/Email/GetUserFolders?UserId=$[UserId]",
    addUserFolder: "/api/Email/AddUserFolder",
    updateUserFolder: "/api/Email/UpdateUserFolder",
    moveToFolder: "/api/Email/MoveToFolder",
  },
  twilio: {
    getToken: "/api/Call/GenerateToken?identity",
    iceServers: "/api/Call/IceServers",
    getVideoCallToken:
      "/api/Call/GenerateToken?identity=$[identity]&roomName=$[roomName]",
    addParticipant: "/api/Call/add-participant",
    addParticipantformData: "/api/Call/incoming",
    MoveToConference: "/api/Call/moveToConference",
    AddParticipant: "/api/Call/addParticipant",
    startRecordingCall: "/api/Call/start-recording",
    stopRecordingCall: "/api/Call/stop-recording",
    getRecordingCall: "/api/Call/get-recording",
    fetchingCallDetail: "/api/Call/GetRecentCalls",
    fetchCallLogsDetails:
      "/api/Call/GetCallRecords?UserId=$[userID]&page=$[page]&pageSize=$[pageSize]&searchTerm=$[searchTerm]",
    getCallProvider: "/api/Call/CallProvider",
    setCallProvider:
      "/api/Call/SetCallProvider?provider=[provider]&userId=[userId]",
    outboundCall: "/api/Call/GetOutboundStatus",
    inprogressCall: "/api/Call/GetInProgressCalls?clientId=$[clientId]",
    groupCall: "/api/Call/call-group",
    createRoom: "/api/Call/CreateRoom",
    group: {
      startGroupRecording: "/api/Call/start-Grouprecording",
      stopGroupRecording: "/api/Call/stop-GroupRecording",
    },
  },
  tasks: {
    getTasksForBoardView:
      "/api/Task/GetTasks?TaskId=$[taskID]&UserId=$[UserId]&Priority=$[Priority]&Deadline=$[Deadline]&AssignedYou=$[assignedYou]&AssignedByYou=$[assignedByYou]",
    addNewTask: "/api/Task/AddTasks",
    updateTask: "/api/Task/UpdateTasks?AssignedYou=$[AssignedYou]",
    GetDataGridTableApi: `/api/Task/TaskManagementGrid?TaskId=$[taskID]&UserId=$[UserId]&Priority=$[Priority]&Deadline=$[Deadline]&AssignedYou=$[assignedYou]&AssignedByYou=$[assignedByYou]`,
    //Get_Api for DataGridViewTable
    GetDataGridTableTaskId: `/api/Task/TaskManagementGrid?TaskId=$[taskID]`,
    GetTaskActivity: "/api/Task/GetTaskActivity?taskId=$[taskId]",
    AddTaskActivity: "/api/Task/AddTaskActivity",
    RemoveComment: "/api/Task/RemoveComment?taskActivityId=$[taskActivityId]",
    UpdateComment: "/api/Task/UpdateComment",
  },
};
